export default __webpack_public_path__ + "static/media/digital_coffee.dbe1a5de.png";